module.exports = __webpack_public_path__ + "e23a7dcaefbde4e74e263247aa42ecd7.ttf";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/fonts/themify.ttf?v=1.0.0
// module id = 570
// module chunks = 0